<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>

          <CCardBody>

                <ReportProductCardexAmount/>

          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];
import BTabs from "../../tabs/BTabs";

import ReportPayReceiveDocs from "./ReportPayReceiveDocs";
import ReportProductCardexAmount from "./ReportProductCardexAmount";
import AccountingReports from "./AccountingReports";
import AccountCirculationReport from "./Reports/AccountCirculationReport";
import PeriodReportAmountCirculation from "./Reports/PeriodReportAmountCirculation";
import FinanceReport from "./Reports/FinanceReport";
import ReportAllProduct from "./Reports/ReportAllProduct";
export default {
  name: 'Login',
  components: {
    BTabs,
    AccountingReports,
    ReportPayReceiveDocs,
    ReportProductCardexAmount,
    AccountCirculationReport,
    PeriodReportAmountCirculation,
    FinanceReport,
    ReportAllProduct,
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,

    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    bus.$on("finance_report_selected", (data) => {
      // alert(data);
      this.active_tab = 1;
     // console.log("clicked"+data)
    });
  }, watch: {

  },
  methods: {

  }
}

</script>
